export default function getFirstAndLastNameByName(name)


{
  const trimmedName = name.trim();
  const splits = trimmedName.split(' ');

  const firstName = splits[0];
  const lastName = splits.length > 1 ? splits.slice(1).join(' ') : '';

  return {
    firstName,
    lastName
  };
}